import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import references from './modules/references';
import lots from './modules/lots';
import files from './modules/files';
import users from './modules/users';
import carriers from './modules/carriers';

Vue.use(Vuex);

export default new Vuex.Store({
	getters: {
		utcOffsetMoscow() {
			return 180;
		}
	},

	modules: {
		app,
		user,
		references,
		lots,
		files,
		users,
		carriers
	}
});
